.m-stat-chip-bar {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2) var(--space-3);
  background: var(--stat-chip-bar-bg);
  border: 1px solid var(--stat-chip-bar-border);
  border-radius: var(--radius-lg);
  padding: var(--space-2-5) var(--space-4);

  &--bare {
    background: none;
    border: none;
    border-radius: var(--radius-none);
    padding: 0;
  }
}
